const operationPackageConfigEn = {
  attribute: {
    usage: {
      itemName: "name",
      definition: "definition",
      usage: "usage",
      systemRequired: "System required",
      notUsed: "Not needed",
      noAttributes: "No attribute information available",
      readOnly: "This item is read-only and cannot be edited",
      allNotUsedDisabled: "At least one item must be used",
    },
    status: {
      readonly: "readonly",
    },
  },
  notUsed: {
    title: "Not used",
    taskTitle: "Tasks not used",
  },
  view: "View",
  success: {
    updateSettingsCompleteTitle: "Update settings complete",
    updateSettingsCompleteDescription: "Settings updated",
    enableActivationTitle: "Enable activation complete",
    enableActivationDescription: "Item enabled",
    disableComplete: "Disable complete",
    itemDisabled: "Item '{{name}}' has been disabled",
    itemDeleted: "Item has been deleted",
    enableTaskComplete: "Enable task complete",
    enableTaskDescription: "Task '{{name}}' has been enabled",
    taskDisabled: "Task '{{name}}' has been disabled",
  },
  error: {
    enableFailed: "Enable failed",
    disableFailed: "Disable failed",
    operationFailed: "Operation failed",
    cannotDisableSystemRequired: "System required items cannot be disabled",
    cannotDisableSystemRequiredTask:
      "Tasks containing system required items cannot be disabled",
    cannotDisableLastItem:
      "The last item in the task cannot be disabled. Consider disabling the task instead.",
    missingTaskInfo:
      "Missing required information: Task ID or attribute group code",
    cannotDisableLastTask: "The last task in the step cannot be disabled.",
  },
  createPatternDialog: {
    title: "Create New Pattern",
    description: "Enter pattern name and description",
    nameLabel: "Pattern Name",
    namePlaceholder: "e.g., New Hire Pattern",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Enter the purpose or features of the pattern",
  },
  packagePatternDetail: {
    configure: "Configure",
    configuring: "Configuring",
  },
};

export default operationPackageConfigEn;
